import React from "react";
import { Box, Typography, CircularProgress, useTheme } from "@mui/material";
import { keyframes } from "@mui/system";

interface LoadingPageProps {
  message?: string;
}

const pulse = keyframes`
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }
  
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
  
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
`;

const LoadingPage: React.FC<LoadingPageProps> = ({ message = "Loading..." }) => {
  const theme = useTheme();

  return (
    <Box
      className="LoadingPage"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        // backgroundColor: theme.palette.background.default,
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: 150,
          height: 150,
          animation: `${pulse} 2s infinite`,
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: theme.palette.primary.main,
        }}
      >
        <CircularProgress
          size={100}
          thickness={2}
          sx={{
            color: theme.palette.primary.contrastText,
          }}
        />
      </Box>
      <Typography
        variant="h5"
        sx={{
          mt: 4,
          fontWeight: "bold",
          color: theme.palette.text.primary,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingPage;
